 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		13: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"default~activity-logs-activity-logs-module~admins-admins-module~appointment-details-appointment-deta~45f4ec03","1":"common","2":"default~activity-logs-activity-logs-module~appointment-details-appointment-details-module~appointmen~04ab3854","3":"default~activity-logs-activity-logs-module~admins-admins-module~appointment-details-appointment-deta~3cfa3794","4":"default~appointment-details-appointment-details-module~banner-add-add-module~banner-banner-module~ba~8d93cf45","5":"default~banner-add-add-module~banner-banner-module~banner-edit-edit-module~category-add-add-module~c~b937cb93","6":"default~admins-admins-module~bank-list-bank-list-module~banner-banner-module~category-category-modul~137d2900","7":"default~activity-logs-activity-logs-module~appointments-appointments-module~bank-list-bank-list-modu~dbc34d38","8":"default~activity-logs-activity-logs-module~appointment-details-appointment-details-module~appointmen~c2ebbef5","9":"default~activity-logs-activity-logs-module~appointment-details-appointment-details-module~appointmen~e8722e8b","10":"default~activity-logs-activity-logs-module~appointment-details-appointment-details-module~appointmen~3450fed8","11":"default~appointment-details-appointment-details-module~doctor-details-doctor-details-module~lab-appo~3650a0dd","12":"default~category-add-add-module~category-edit-edit-module~tests-add-add-module~tests-edit-edit-module","14":"default~labs-add-add-module~labs-labs-module","15":"default~payouts-payouts-module~second-opinion-details-second-opinion-details-module","16":"activity-logs-activity-logs-module","17":"admins-admins-module","18":"appointment-details-appointment-details-module","19":"appointments-appointments-module","20":"bank-list-bank-list-module","21":"banner-add-add-module","22":"banner-banner-module","23":"banner-edit-edit-module","24":"category-add-add-module","25":"category-category-module","26":"category-edit-edit-module","27":"coupons-coupons-module","28":"coupons-edit-edit-module","29":"create-admin-create-admin-module","30":"dashboard-dashboard-module","31":"dashboard-new-dashboard-new-module","32":"dicom-files-dicom-files-module","33":"doctor-details-doctor-details-module","34":"doctor-profile-doctor-profile-module","35":"doctors-doctors-module","36":"doctors-payout-doctors-payout-module","37":"health-data-health-data-module","38":"lab-appointment-edit-edit-module","39":"lab-appointment-lab-appointment-module","40":"lab-appointment-view-view-module","41":"labs-add-add-module","42":"labs-edit-edit-module","43":"labs-labs-module","44":"languages-languages-module","45":"login-login-module","47":"order-management-edit-edit-module","48":"order-management-order-management-module","49":"order-management-view-view-module","50":"organizations-organizations-module","51":"patient-details-patient-details-module","52":"patients-patients-module","53":"payouts-payouts-module","56":"product-videos-product-videos-module","57":"products-add-add-module","58":"products-edit-edit-module","59":"products-products-module","60":"radiology-center-registartion-radiology-center-registartion-module","61":"radiology-centers-radiology-centers-module","62":"reset-password-reset-password-module","63":"revenue-new-revenue-new-module","64":"revenue-revenue-module","65":"second-opinion-details-second-opinion-details-module","66":"second-opinion-second-opinion-module","67":"specialities-specialities-module","69":"test-price-add-add-module","70":"test-price-edit-edit-module","71":"test-price-test-price-module","72":"tests-add-add-module","73":"tests-edit-edit-module","74":"tests-tests-module","75":"update-admin-update-admin-module","76":"update-doctor-profile-update-doctor-profile-module"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
